import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './ReplenishProductCard.module.scss';
import ProductImagesSlider from '../ProductImagesSlider';
import Price from '../Price';
import { shortTitle } from '../../../utils/textHelper';

function ReplenishProductCard(props) {
  const { product, openModal } = props;
  const card = useRef(null);

  const hasInventory = product.available_inventory > 0;

  if (!product) {
    return null;
  }

  return (
    <div className={styles.resultsProduct} onClick={() => openModal(product.model)} ref={card}>
      <div className={hasInventory ? styles.wrapper : styles.wrapperNoInventory}>
        <div className={styles.wp}>
          <div className={styles.top} />
          <div className={styles.img_block}>
            <ProductImagesSlider images={product.square_images} cardRef={card} />
          </div>
          <div className={styles.desc}>
            <p className={styles.pt}>{shortTitle(product.title)}</p>
            <p className={styles.price}>
              <Price max={product.wholesale_price_max} min={product.wholesale_price_min} currency={product.currency} />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReplenishProductCard;

ReplenishProductCard.propTypes = {
  product: PropTypes.shape({
    images: PropTypes.array,
    variants: PropTypes.array,
    model: PropTypes.string,
  }).isRequired,
  openModal: PropTypes.func.isRequired,
};
